// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__19ZXj","statusContainer":"styles_statusContainer__2EO7I"};